import React, { useEffect, useState } from 'react'
import { RedirectButton } from 'components/atoms'
import {
  CmsHomepageSectionCarouselBanners
} from 'domains/cms-homepage-section/organisms'
import CmsHomepageSectionApiV2 from 'api/v2/admins/cms-homepage-sections-api-v2'
import CmsHomepageSectionOfflineStoresApiV2 from 'api/v2/admins/cms-homepage-section-offline-stores-api-v2'
import PropTypes from 'prop-types'
import { Alert, Col, Row, Spinner } from 'reactstrap'
import NewArrivalProductPlaceholder from './new-arrival-product-placeholder'
import CommFavPlaceholder from './comm-fav-placeholder'

import CmsNoticebarApiV2 from 'api/v2/admins/cms-noticebar-api-v2'
import CmsHomepageSectionCommunityFavoritesApiV2 from 'api/v2/admins/cms-homepage-section-community-favorites-api-v2'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const CmsHomepageSectionListPage = ({ pageUtils }) => {

  const [ sections, setSections ]                       = useState([])
  const [ offlineStoreSection, setOfflineStoreSection ] = useState([])
  const [ isLoading, setIsLoading ]                     = useState(true)

  const [ noticebar, setNoticebar ]                   = useState({})
  const [ isLoadingNoticebar, setIsLoadingNoticebar ] = useState(true)

  const [ commFavs, setCommFavs ]                   = useState([])
  const [ isLoadingCommFavs, setIsLoadingCommFavs ] = useState(true)

  useEffect(() => {
    CmsHomepageSectionApiV2.get()
      .then((response) => {
        setSections(response.data.sections)
      })
      .catch(() => {
        pageUtils.setAlertMsg('Unable to fetch Cms Homepage Sections', 'warning')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [ pageUtils ])

  useEffect(() => {
    CmsHomepageSectionOfflineStoresApiV2.get()
      .then((response) => {
        setOfflineStoreSection(response.data.offline_stores)
      })
      .catch(() => {
        pageUtils.setAlertMsg('Unable to fetch Cms Homepage Offline Store', 'warning')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [ pageUtils ])

  useEffect(() => {
    CmsNoticebarApiV2.get()
      .then((response) => {
        setNoticebar(response.data.noticebar)
      })
      .catch(() => {
        pageUtils.setAlertMsg('Unable to fetch Cms Noticebar', 'warning')
      })
      .finally(() => {
        setIsLoadingNoticebar(false)
      })
  }, [ pageUtils ])

  useEffect(() => {
    CmsHomepageSectionCommunityFavoritesApiV2.get({ tableState: null })
      .then((response) => {
        setCommFavs(response.data.community_favorites)
      })
      .catch(() => {
        pageUtils.setAlertMsg('Unable to fetch Cms Community Favourites', 'warning')
      })
      .finally(() => {
        setIsLoadingCommFavs(false)
      })
  }, [ pageUtils ])

  return (
    <>
      <h1>Homepage</h1>
      <p className='mb-0'>Update content for tinkerlust.com homepage. Only the following can be edited in Ops Dash:</p>
      <ul>
        <li>Noticebar</li>
        <li>Banners</li>
        <li>Sub Banners</li>
        <li>Designer Spotlight</li>
        <li>Community Favourites</li>
      </ul>
      {
        isLoading
          ? (
            <Alert color='primary'>
              <Spinner/> Loading...
            </Alert>
          )
          : (
            <>
              <Row>
                <Col sm={ 8 }>
                  <h2>Noticebar</h2>
                  <div className='p-3 bg-gray text-center'>
                    {
                      isLoadingNoticebar
                        ? <Spinner />
                        : noticebar.title
                    }
                  </div>
                  <RedirectButton
                    color={ 'primary float-right' }
                    text={ 'Edit Noticebar' }
                    path={ '/app/cms/noticebar/edit' }
                  />
                </Col>
              </Row>

              <Row>
                <Col sm={ 12 }>
                  <h2>Banner</h2>
                  <p>Displayed as a carousel in Shopfront</p>
                  <CmsHomepageSectionCarouselBanners banners={ sections.banners } />
                </Col>
              </Row>


              <Row className='py-3'>
                <Col sm={ 8 }>
                  <h2>Luxury Products</h2>
                  <Alert color='info'>Luxury Products section is automatically updated by the system.</Alert>
                </Col>
              </Row>

              <Row className='py-3'>
                <Col sm={ 8 }>
                  <h2>New Arrivals</h2>
                  <Alert color='info'>New Arrivals section is automatically updated by the system.</Alert>
                  <NewArrivalProductPlaceholder/>
                </Col>
              </Row>

              <Row className='py-3'>
                <Col sm={ 8 }>
                  <h2>Community Favourites</h2>
                  {
                    isLoadingCommFavs
                      ? <Spinner/>
                      : <CommFavPlaceholder commFavs={ commFavs } />
                  }
                  <RedirectButton
                    color={ 'primary float-right' }
                    text={ 'Edit Comm. Fav.' }
                    path={ '/app/cms/homepage/community-favorites' }
                  />
                </Col>
              </Row>

              <Row className='py-3'>
                <Col sm={ 8 }>
                  <h2>Offline Store Banner</h2>
                  <p>Displayed as a Banner in Shopfront</p>
                  <CmsHomepageSectionCarouselBanners banners={ offlineStoreSection } />
                </Col>
              </Row>


              <Row className='py-3'>
                <Col sm={ 8 }>
                  <h2>Featured Sellers</h2>
                  <Alert color='info'>
                    { 'Featured Seller section is updated automatically by the system. Orderd by latest live date.' }
                  </Alert>
                </Col>
              </Row>

            </>
          )
      }
    </>

  )
}

CmsHomepageSectionListPage.propTypes    = propTypes
CmsHomepageSectionListPage.defaultProps = defaultProps

export default CmsHomepageSectionListPage
